module.exports = __webpack_public_path__ + "static/p11_nota03-1ad4be9ea7ba8952361f08224eb5afe9.png";